import { createStore, compose, applyMiddleware } from "redux";
import thunk from "redux-thunk";
import reduxImmutableStateInvariant from "redux-immutable-state-invariant";
import reducer from "./reducer";

const middlewares = [
	// Add other middleware on this line...
	reduxImmutableStateInvariant(),
	// thunk middleware can also accept an extra argument to be passed to each thunk action
	// https://github.com/gaearon/redux-thunk#injecting-a-custom-argument
	thunk,
];

const store = createStore(reducer, compose(applyMiddleware(...middlewares)));

export default store;
